import { Box, Container, Grid2 as Grid } from '@mui/material';
import ContactDetails from '../components/coreLayout/ContactDetails';
import PageTitle from '../components/coreLayout/PageTitle';
import Seo from '../components/coreLayout/Seo';

const contactSx = {
    containerPadding: {
        paddingLeft: { xs: '10px', sm: '24px' },
        paddingRight: { xs: '10px', sm: '24px' },
    },
    lowerContainerPadding: {
        paddingBottom: '50px',
        paddingLeft: { xs: '10px', sm: '24px' },
        paddingRight: { xs: '10px', sm: '24px' },
    },
    mapBox: {
        width: '100%',
        height: { xs: 350, sm: 450 },
        padding: '20px',
    },
} as const;

export default function Contact() {
    return (
        <>
            <Seo
                title="Contact GSL Aviation | Cairns Scenic Flights & Reef Tours"
                description="Get in touch with the GSL Aviation team in Cairns for scenic flights, Great Barrier Reef tours and air charter enquiries."
                path="/contactus"
            />
            <Container maxWidth="lg" sx={contactSx.containerPadding}>
                <PageTitle title="Contact Us" tagline="Get in touch with our Cairns office" compact />
            </Container>
            <Container maxWidth="lg" sx={contactSx.lowerContainerPadding}>
                <Grid container spacing={2} alignItems="center">
                    <Grid size={{ xs: 12, md: 5 }}>
                        <ContactDetails
                            mapLink="https://goo.gl/maps/LQDRrKGD5kQnmtG39"
                            address="83 Royal Flying Doctor St, Cairns QLD 4870"
                            phone="07 4015 4191"
                            whatsapp="+61 483 966 894"
                            email="cairns@gslaviation.com.au"
                            hideSocial
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 7 }}>
                        <Box sx={contactSx.mapBox}>
                            <iframe
                                title="GSL Aviation location on Google Maps"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3817.8755266446638!2d145.74669421603218!3d-16.882050888383326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x697865e7d583b86d%3A0x83f0ad265395f7cb!2sGSL%20Aviation!5e0!3m2!1sen!2sau!4v1633417077638!5m2!1sen!2sau"
                                width="100%"
                                height="100%"
                                style={{ border: 0, borderRadius: 10 }}
                                allowFullScreen={false}
                                loading="lazy"
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}
